import { Box, Text } from '@factorialco/deprecated-design-system'
import { Spinner } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import emptyStateBg from 'modules/pages/lib/assets/emptyStateBackground.png'

export const UploadingSkeleton = () => {
  return (
    <Box
      gap="s16"
      alignItems="center"
      justifyContent="center"
      position="absolute"
      style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
    >
      <img src={emptyStateBg} alt="Page empty state background" width="530px" height="330px" />
      <Box
        alignItems="center"
        justifyContent="center"
        position="absolute"
        background="grey300"
        borderRadius={{ all: 'abs012' }}
        padding="s8"
        style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
        gap="s8"
        flexDirection="row"
      >
        <Spinner size="small" />
        <Text.Normal color="grey800" size="200" weight="medium">
          {i18n.t('pages.upload_files_modal.upload.loading_messages.creating_documents')}
        </Text.Normal>
      </Box>
    </Box>
  )
}
